import React from 'react';

const Newyork = () => {
  return (
    <div>
      
    </div>
  );
}

export default Newyork;
